import React, { InputHTMLAttributes, useEffect } from 'react';

import {
  FieldError,
  Path,
  RegisterOptions,
  UseFormWatch,
  UseFormRegister,
  UseFormUnregister,
  FieldValues,
} from 'react-hook-form';

import { WarningIcon } from '../../Icons/WarningIcon';

interface IProps<FormState extends FieldValues = object> {
  error?: FieldError;
  label: string;
  id: Path<FormState>;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  watch: UseFormWatch<FormState>;
  register: UseFormRegister<FormState>;
  unregister?: UseFormUnregister<FormState>;
  registerOptions?: RegisterOptions;
  className?: string;
  customLabelStyles?: string;
}
export function HooksFormToggle<FormState extends FieldValues>({
  label,
  error,
  id,
  inputProps = {},
  watch,
  register,
  registerOptions = {},
  className = '',
  unregister,
}: IProps<FormState>) {
  // Lets watch for state changes of input
  const isChecked = watch(id);

  useEffect(() => {
    return () => {
      if (unregister) {
        unregister(id);
      }
    };
  }, [id, unregister]);

  return (
    <div className={`${className} flex flex-col`}>
      <input
        id={id}
        placeholder={label}
        type="checkbox"
        className="hidden"
        {...inputProps}
        {...register(id, registerOptions)}
      />
      <label htmlFor={id} className="flex flex-row items-center">
        <span
          className={`border-trench flex size-6 items-center justify-center rounded-full border-2 ${
            isChecked ? 'bg-trench' : 'bg-white'
          }`}
        >
          <svg
            width="20"
            height="11"
            viewBox="0 0 14 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="block"
          >
            <path
              d="M11.5218 1.06429C11.9291 0.656995 12.5895 0.656995 12.9968 1.06429C13.4041 1.47159 13.4041 2.13195 12.9968 2.53925L5.49333 10.0427C5.08603 10.45 4.42567 10.45 4.01837 10.0427L0.60772 6.63204C0.200422 6.22474 0.200421 5.56438 0.60772 5.15708C1.01502 4.74978 1.67538 4.74978 2.08268 5.15708L4.75585 7.83025L11.5218 1.06429Z"
              fill="white"
              stroke="white"
              strokeWidth="0.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <span className={`${inputProps.disabled ? 'text-disabled' : 'text-abyss'} ml-4 text-sm`}>
          {label}
        </span>
      </label>
      {error && (
        <div className="text-error-shade mt-1 text-xs">
          <span className="mr-1">
            <WarningIcon width={12} height={12} />
          </span>
          {error.message}
        </div>
      )}
    </div>
  );
}
